import * as yup from 'yup';

export class CustomDocumentPdfFields {
  public static fieldName: string = 'customDocument' as const;
  public static validator: yup.MixedSchema<
    File | undefined | null,
    yup.AnyObject,
    File | undefined | null
  > = yup
    .mixed<File>()
    .optional()
    .nullable()
    .test('is-file', 'is-file', (value) => {
      if (!value) {
        return true;
      }
      return value instanceof File;
    })
    .test('file-type', 'is-pdf', (value) => {
      if (!value) return true;
      return value.type === 'application/pdf';
    });
}
